import { render, staticRenderFns } from "./TopProducts.vue?vue&type=template&id=fda70c6e&"
import script from "./TopProducts.vue?vue&type=script&lang=ts&"
export * from "./TopProducts.vue?vue&type=script&lang=ts&"
import style0 from "./TopProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports